module.exports = __webpack_public_path__ + "img/013-italy.2063c347.svg";